$.fn.lib_reCaptcha = function(attr) {
    let elm = $(this);
    if(elm.length) {
        const apiKey = elm.data(attr);
        $.importScript(cdnjs.recaptcha.replace("{apikey}",apiKey), function(){
            window.grecaptcha.enterprise.ready(function() {
                window.grecaptcha.enterprise.execute(apiKey, { action: 'form' }).then(function(token) {
                    $('#gtoken').val(token);
                    //elm[0].dispatchEvent(new CustomEvent('submit', { cancelable: true, detail: { recaptchaExecuted: true } }));
                });
            });
        });
    }
};